/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Entry } from './Entry';
import {
    EntryFromJSON,
    EntryFromJSONTyped,
    EntryToJSON,
    EntryToJSONTyped,
} from './Entry';
import type { ConclusionGroup } from './ConclusionGroup';
import {
    ConclusionGroupFromJSON,
    ConclusionGroupFromJSONTyped,
    ConclusionGroupToJSON,
    ConclusionGroupToJSONTyped,
} from './ConclusionGroup';
import type { ResultDocumentFile } from './ResultDocumentFile';
import {
    ResultDocumentFileFromJSON,
    ResultDocumentFileFromJSONTyped,
    ResultDocumentFileToJSON,
    ResultDocumentFileToJSONTyped,
} from './ResultDocumentFile';
import type { ExpressionCCL } from './ExpressionCCL';
import {
    ExpressionCCLFromJSON,
    ExpressionCCLFromJSONTyped,
    ExpressionCCLToJSON,
    ExpressionCCLToJSONTyped,
} from './ExpressionCCL';
import type { UiIdentifier } from './UiIdentifier';
import {
    UiIdentifierFromJSON,
    UiIdentifierFromJSONTyped,
    UiIdentifierToJSON,
    UiIdentifierToJSONTyped,
} from './UiIdentifier';

/**
 * 
 * @export
 * @interface PatientSummaryResponse
 */
export interface PatientSummaryResponse {
    /**
     * 
     * @type {number}
     * @memberof PatientSummaryResponse
     */
    expressionId?: number;
    /**
     * 
     * @type {number}
     * @memberof PatientSummaryResponse
     */
    conceptGroupId?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    metaDataText?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientSummaryResponse
     */
    isCorrected?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatientSummaryResponse
     */
    isInterpretable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    languageIso?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    originalText?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    multiDosageText?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientSummaryResponse
     */
    isMatched?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    matchedText?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    unMatchedText?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    expressionType?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    siteRoot?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientSummaryResponse
     */
    siteRootIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    siteRootTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    siteRootGroup?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientSummaryResponse
     */
    siteRootGroupIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    aggressorRoot?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientSummaryResponse
     */
    aggressorRootIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    aggressorRootTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    aggressorRootGroup?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientSummaryResponse
     */
    aggressorRootGroupIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    timelineStart?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    timelineEnd?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    durationType?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    healthProType?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    findingProcedureRoot?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctAdministrationRoute?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctAdministrationRouteTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctProxyKey?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctSite?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctSiteTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctSiteProxy?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctSiteProxyTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctAggressor?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctAggressorTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctAggressorProxy?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctAggressorProxyTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctNestingAggressor?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctNestingAggressorTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctAggressorContentProxy?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctAggressorContentProxyTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    aggressorContentRoot?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    aggressorContentRootTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctSubstance1?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctSubstance1Term?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctSubstance2?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctSubstance2Term?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctContentFamily2?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctSubstance3?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctSubstance3Term?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctContentFamily3?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctSubstance4?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctSubstance4Term?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctContentFamily4?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctSubstance5?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctSubstance5Term?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctContentFamily5?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctSubstance6?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctSubstance6Term?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctContentFamily6?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctContentFamily1?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientSummaryResponse
     */
    sctContentFamily1Index?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctContentFamily1Term?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientSummaryResponse
     */
    sctContentFamily2Index?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctContentFamily2Term?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientSummaryResponse
     */
    sctContentFamily3Index?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctContentFamily3Term?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientSummaryResponse
     */
    sctContentFamily4Index?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctContentFamily4Term?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientSummaryResponse
     */
    sctContentFamily5Index?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctContentFamily5Term?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientSummaryResponse
     */
    sctContentFamily6Index?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctContentFamily6Term?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctSubstanceKey?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctLabKey?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctFindingProcedure?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctFindingProcedureTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctFindingProcedureProxy?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctFindingProcedureProxyTerm?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientSummaryResponse
     */
    isSpecialtyOverImaging?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    laterality?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    lateralityTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctBodyQualifier?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctBodyQualifierTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctSubstanceReaction?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctSubstanceReactionTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctLabCollection?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctLabCollectionTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctSiteFinding?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctSiteFindingTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctSiteFindingProxy?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctSiteFindingProxyTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    siteFindingRoot?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctMorphology?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctMorphologyTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctNormalityContext?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    numericalValue?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctUnit?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    ucumUnit?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientSummaryResponse
     */
    isNumerical?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    normalityType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientSummaryResponse
     */
    isNormal?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatientSummaryResponse
     */
    isOngoing?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    standardizedNumerical?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    standardizedUpperLimit?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    standardizedLowerLimit?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    standardizedUnitTerm?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientSummaryResponse
     */
    isNegated?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctCertaintyContext?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctCertaintyContextTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctProcedureContext?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctProcedureContextTerm?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientSummaryResponse
     */
    isFact?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctPersonInformer?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctPersonInformerTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctPersonSubject?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctPersonSubjectTerm?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientSummaryResponse
     */
    isFamilyHistory?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    sctUnitTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    galenic?: string;
    /**
     * 
     * @type {ExpressionCCL}
     * @memberof PatientSummaryResponse
     */
    expressionCcl?: ExpressionCCL;
    /**
     * 
     * @type {Entry}
     * @memberof PatientSummaryResponse
     */
    entry?: Entry;
    /**
     * 
     * @type {ConclusionGroup}
     * @memberof PatientSummaryResponse
     */
    conclusionGroup?: ConclusionGroup;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    text?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    posoText?: string;
    /**
     * 
     * @type {UiIdentifier}
     * @memberof PatientSummaryResponse
     */
    id?: UiIdentifier;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    dbText?: string;
    /**
     * 
     * @type {ResultDocumentFile}
     * @memberof PatientSummaryResponse
     */
    resultDocumentFile?: ResultDocumentFile;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    patientSummaryId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientSummaryResponse
     */
    deletable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientSummaryResponse
     */
    summaryType?: PatientSummaryResponseSummaryTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PatientSummaryResponse
     */
    hasExclamation?: boolean;
}


/**
 * @export
 */
export const PatientSummaryResponseSummaryTypeEnum = {
    Basic: 'BASIC',
    Monitored: 'MONITORED',
    Ecosystem: 'ECOSYSTEM',
    History: 'HISTORY'
} as const;
export type PatientSummaryResponseSummaryTypeEnum = typeof PatientSummaryResponseSummaryTypeEnum[keyof typeof PatientSummaryResponseSummaryTypeEnum];


/**
 * Check if a given object implements the PatientSummaryResponse interface.
 */
export function instanceOfPatientSummaryResponse(value: object): value is PatientSummaryResponse {
    return true;
}

export function PatientSummaryResponseFromJSON(json: any): PatientSummaryResponse {
    return PatientSummaryResponseFromJSONTyped(json, false);
}

export function PatientSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientSummaryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'expressionId': json['expressionId'] == null ? undefined : json['expressionId'],
        'conceptGroupId': json['conceptGroupId'] == null ? undefined : json['conceptGroupId'],
        'metaDataText': json['metaDataText'] == null ? undefined : json['metaDataText'],
        'isCorrected': json['isCorrected'] == null ? undefined : json['isCorrected'],
        'isInterpretable': json['isInterpretable'] == null ? undefined : json['isInterpretable'],
        'created': json['created'] == null ? undefined : json['created'],
        'updated': json['updated'] == null ? undefined : json['updated'],
        'languageIso': json['languageIso'] == null ? undefined : json['languageIso'],
        'originalText': json['originalText'] == null ? undefined : json['originalText'],
        'multiDosageText': json['multiDosageText'] == null ? undefined : json['multiDosageText'],
        'isMatched': json['isMatched'] == null ? undefined : json['isMatched'],
        'matchedText': json['matchedText'] == null ? undefined : json['matchedText'],
        'unMatchedText': json['unMatchedText'] == null ? undefined : json['unMatchedText'],
        'expressionType': json['expressionType'] == null ? undefined : json['expressionType'],
        'siteRoot': json['siteRoot'] == null ? undefined : json['siteRoot'],
        'siteRootIndex': json['siteRootIndex'] == null ? undefined : json['siteRootIndex'],
        'siteRootTerm': json['siteRootTerm'] == null ? undefined : json['siteRootTerm'],
        'siteRootGroup': json['siteRootGroup'] == null ? undefined : json['siteRootGroup'],
        'siteRootGroupIndex': json['siteRootGroupIndex'] == null ? undefined : json['siteRootGroupIndex'],
        'aggressorRoot': json['aggressorRoot'] == null ? undefined : json['aggressorRoot'],
        'aggressorRootIndex': json['aggressorRootIndex'] == null ? undefined : json['aggressorRootIndex'],
        'aggressorRootTerm': json['aggressorRootTerm'] == null ? undefined : json['aggressorRootTerm'],
        'aggressorRootGroup': json['aggressorRootGroup'] == null ? undefined : json['aggressorRootGroup'],
        'aggressorRootGroupIndex': json['aggressorRootGroupIndex'] == null ? undefined : json['aggressorRootGroupIndex'],
        'timelineStart': json['timelineStart'] == null ? undefined : json['timelineStart'],
        'timelineEnd': json['timelineEnd'] == null ? undefined : json['timelineEnd'],
        'durationType': json['durationType'] == null ? undefined : json['durationType'],
        'healthProType': json['healthProType'] == null ? undefined : json['healthProType'],
        'findingProcedureRoot': json['findingProcedureRoot'] == null ? undefined : json['findingProcedureRoot'],
        'sctAdministrationRoute': json['sctAdministrationRoute'] == null ? undefined : json['sctAdministrationRoute'],
        'sctAdministrationRouteTerm': json['sctAdministrationRouteTerm'] == null ? undefined : json['sctAdministrationRouteTerm'],
        'sctProxyKey': json['sctProxyKey'] == null ? undefined : json['sctProxyKey'],
        'sctSite': json['sctSite'] == null ? undefined : json['sctSite'],
        'sctSiteTerm': json['sctSiteTerm'] == null ? undefined : json['sctSiteTerm'],
        'sctSiteProxy': json['sctSiteProxy'] == null ? undefined : json['sctSiteProxy'],
        'sctSiteProxyTerm': json['sctSiteProxyTerm'] == null ? undefined : json['sctSiteProxyTerm'],
        'sctAggressor': json['sctAggressor'] == null ? undefined : json['sctAggressor'],
        'sctAggressorTerm': json['sctAggressorTerm'] == null ? undefined : json['sctAggressorTerm'],
        'sctAggressorProxy': json['sctAggressorProxy'] == null ? undefined : json['sctAggressorProxy'],
        'sctAggressorProxyTerm': json['sctAggressorProxyTerm'] == null ? undefined : json['sctAggressorProxyTerm'],
        'sctNestingAggressor': json['sctNestingAggressor'] == null ? undefined : json['sctNestingAggressor'],
        'sctNestingAggressorTerm': json['sctNestingAggressorTerm'] == null ? undefined : json['sctNestingAggressorTerm'],
        'sctAggressorContentProxy': json['sctAggressorContentProxy'] == null ? undefined : json['sctAggressorContentProxy'],
        'sctAggressorContentProxyTerm': json['sctAggressorContentProxyTerm'] == null ? undefined : json['sctAggressorContentProxyTerm'],
        'aggressorContentRoot': json['aggressorContentRoot'] == null ? undefined : json['aggressorContentRoot'],
        'aggressorContentRootTerm': json['aggressorContentRootTerm'] == null ? undefined : json['aggressorContentRootTerm'],
        'sctSubstance1': json['sctSubstance1'] == null ? undefined : json['sctSubstance1'],
        'sctSubstance1Term': json['sctSubstance1Term'] == null ? undefined : json['sctSubstance1Term'],
        'sctSubstance2': json['sctSubstance2'] == null ? undefined : json['sctSubstance2'],
        'sctSubstance2Term': json['sctSubstance2Term'] == null ? undefined : json['sctSubstance2Term'],
        'sctContentFamily2': json['sctContentFamily2'] == null ? undefined : json['sctContentFamily2'],
        'sctSubstance3': json['sctSubstance3'] == null ? undefined : json['sctSubstance3'],
        'sctSubstance3Term': json['sctSubstance3Term'] == null ? undefined : json['sctSubstance3Term'],
        'sctContentFamily3': json['sctContentFamily3'] == null ? undefined : json['sctContentFamily3'],
        'sctSubstance4': json['sctSubstance4'] == null ? undefined : json['sctSubstance4'],
        'sctSubstance4Term': json['sctSubstance4Term'] == null ? undefined : json['sctSubstance4Term'],
        'sctContentFamily4': json['sctContentFamily4'] == null ? undefined : json['sctContentFamily4'],
        'sctSubstance5': json['sctSubstance5'] == null ? undefined : json['sctSubstance5'],
        'sctSubstance5Term': json['sctSubstance5Term'] == null ? undefined : json['sctSubstance5Term'],
        'sctContentFamily5': json['sctContentFamily5'] == null ? undefined : json['sctContentFamily5'],
        'sctSubstance6': json['sctSubstance6'] == null ? undefined : json['sctSubstance6'],
        'sctSubstance6Term': json['sctSubstance6Term'] == null ? undefined : json['sctSubstance6Term'],
        'sctContentFamily6': json['sctContentFamily6'] == null ? undefined : json['sctContentFamily6'],
        'sctContentFamily1': json['sctContentFamily1'] == null ? undefined : json['sctContentFamily1'],
        'sctContentFamily1Index': json['sctContentFamily1Index'] == null ? undefined : json['sctContentFamily1Index'],
        'sctContentFamily1Term': json['sctContentFamily1Term'] == null ? undefined : json['sctContentFamily1Term'],
        'sctContentFamily2Index': json['sctContentFamily2Index'] == null ? undefined : json['sctContentFamily2Index'],
        'sctContentFamily2Term': json['sctContentFamily2Term'] == null ? undefined : json['sctContentFamily2Term'],
        'sctContentFamily3Index': json['sctContentFamily3Index'] == null ? undefined : json['sctContentFamily3Index'],
        'sctContentFamily3Term': json['sctContentFamily3Term'] == null ? undefined : json['sctContentFamily3Term'],
        'sctContentFamily4Index': json['sctContentFamily4Index'] == null ? undefined : json['sctContentFamily4Index'],
        'sctContentFamily4Term': json['sctContentFamily4Term'] == null ? undefined : json['sctContentFamily4Term'],
        'sctContentFamily5Index': json['sctContentFamily5Index'] == null ? undefined : json['sctContentFamily5Index'],
        'sctContentFamily5Term': json['sctContentFamily5Term'] == null ? undefined : json['sctContentFamily5Term'],
        'sctContentFamily6Index': json['sctContentFamily6Index'] == null ? undefined : json['sctContentFamily6Index'],
        'sctContentFamily6Term': json['sctContentFamily6Term'] == null ? undefined : json['sctContentFamily6Term'],
        'sctSubstanceKey': json['sctSubstanceKey'] == null ? undefined : json['sctSubstanceKey'],
        'sctLabKey': json['sctLabKey'] == null ? undefined : json['sctLabKey'],
        'sctFindingProcedure': json['sctFindingProcedure'] == null ? undefined : json['sctFindingProcedure'],
        'sctFindingProcedureTerm': json['sctFindingProcedureTerm'] == null ? undefined : json['sctFindingProcedureTerm'],
        'sctFindingProcedureProxy': json['sctFindingProcedureProxy'] == null ? undefined : json['sctFindingProcedureProxy'],
        'sctFindingProcedureProxyTerm': json['sctFindingProcedureProxyTerm'] == null ? undefined : json['sctFindingProcedureProxyTerm'],
        'isSpecialtyOverImaging': json['isSpecialtyOverImaging'] == null ? undefined : json['isSpecialtyOverImaging'],
        'laterality': json['laterality'] == null ? undefined : json['laterality'],
        'lateralityTerm': json['lateralityTerm'] == null ? undefined : json['lateralityTerm'],
        'sctBodyQualifier': json['sctBodyQualifier'] == null ? undefined : json['sctBodyQualifier'],
        'sctBodyQualifierTerm': json['sctBodyQualifierTerm'] == null ? undefined : json['sctBodyQualifierTerm'],
        'sctSubstanceReaction': json['sctSubstanceReaction'] == null ? undefined : json['sctSubstanceReaction'],
        'sctSubstanceReactionTerm': json['sctSubstanceReactionTerm'] == null ? undefined : json['sctSubstanceReactionTerm'],
        'sctLabCollection': json['sctLabCollection'] == null ? undefined : json['sctLabCollection'],
        'sctLabCollectionTerm': json['sctLabCollectionTerm'] == null ? undefined : json['sctLabCollectionTerm'],
        'sctSiteFinding': json['sctSiteFinding'] == null ? undefined : json['sctSiteFinding'],
        'sctSiteFindingTerm': json['sctSiteFindingTerm'] == null ? undefined : json['sctSiteFindingTerm'],
        'sctSiteFindingProxy': json['sctSiteFindingProxy'] == null ? undefined : json['sctSiteFindingProxy'],
        'sctSiteFindingProxyTerm': json['sctSiteFindingProxyTerm'] == null ? undefined : json['sctSiteFindingProxyTerm'],
        'siteFindingRoot': json['siteFindingRoot'] == null ? undefined : json['siteFindingRoot'],
        'sctMorphology': json['sctMorphology'] == null ? undefined : json['sctMorphology'],
        'sctMorphologyTerm': json['sctMorphologyTerm'] == null ? undefined : json['sctMorphologyTerm'],
        'sctNormalityContext': json['sctNormalityContext'] == null ? undefined : json['sctNormalityContext'],
        'numericalValue': json['numericalValue'] == null ? undefined : json['numericalValue'],
        'sctUnit': json['sctUnit'] == null ? undefined : json['sctUnit'],
        'ucumUnit': json['ucumUnit'] == null ? undefined : json['ucumUnit'],
        'isNumerical': json['isNumerical'] == null ? undefined : json['isNumerical'],
        'normalityType': json['normalityType'] == null ? undefined : json['normalityType'],
        'isNormal': json['isNormal'] == null ? undefined : json['isNormal'],
        'isOngoing': json['isOngoing'] == null ? undefined : json['isOngoing'],
        'standardizedNumerical': json['standardizedNumerical'] == null ? undefined : json['standardizedNumerical'],
        'standardizedUpperLimit': json['standardizedUpperLimit'] == null ? undefined : json['standardizedUpperLimit'],
        'standardizedLowerLimit': json['standardizedLowerLimit'] == null ? undefined : json['standardizedLowerLimit'],
        'standardizedUnitTerm': json['standardizedUnitTerm'] == null ? undefined : json['standardizedUnitTerm'],
        'isNegated': json['isNegated'] == null ? undefined : json['isNegated'],
        'sctCertaintyContext': json['sctCertaintyContext'] == null ? undefined : json['sctCertaintyContext'],
        'sctCertaintyContextTerm': json['sctCertaintyContextTerm'] == null ? undefined : json['sctCertaintyContextTerm'],
        'sctProcedureContext': json['sctProcedureContext'] == null ? undefined : json['sctProcedureContext'],
        'sctProcedureContextTerm': json['sctProcedureContextTerm'] == null ? undefined : json['sctProcedureContextTerm'],
        'isFact': json['isFact'] == null ? undefined : json['isFact'],
        'sctPersonInformer': json['sctPersonInformer'] == null ? undefined : json['sctPersonInformer'],
        'sctPersonInformerTerm': json['sctPersonInformerTerm'] == null ? undefined : json['sctPersonInformerTerm'],
        'sctPersonSubject': json['sctPersonSubject'] == null ? undefined : json['sctPersonSubject'],
        'sctPersonSubjectTerm': json['sctPersonSubjectTerm'] == null ? undefined : json['sctPersonSubjectTerm'],
        'isFamilyHistory': json['isFamilyHistory'] == null ? undefined : json['isFamilyHistory'],
        'sctUnitTerm': json['sctUnitTerm'] == null ? undefined : json['sctUnitTerm'],
        'galenic': json['galenic'] == null ? undefined : json['galenic'],
        'expressionCcl': json['expressionCcl'] == null ? undefined : ExpressionCCLFromJSON(json['expressionCcl']),
        'entry': json['entry'] == null ? undefined : EntryFromJSON(json['entry']),
        'conclusionGroup': json['conclusionGroup'] == null ? undefined : ConclusionGroupFromJSON(json['conclusionGroup']),
        'text': json['text'] == null ? undefined : json['text'],
        'posoText': json['posoText'] == null ? undefined : json['posoText'],
        'id': json['id'] == null ? undefined : UiIdentifierFromJSON(json['id']),
        'dbText': json['dbText'] == null ? undefined : json['dbText'],
        'resultDocumentFile': json['resultDocumentFile'] == null ? undefined : ResultDocumentFileFromJSON(json['resultDocumentFile']),
        'patientSummaryId': json['patientSummaryId'] == null ? undefined : json['patientSummaryId'],
        'deletable': json['deletable'] == null ? undefined : json['deletable'],
        'summaryType': json['summaryType'] == null ? undefined : json['summaryType'],
        'hasExclamation': json['hasExclamation'] == null ? undefined : json['hasExclamation'],
    };
}

export function PatientSummaryResponseToJSON(json: any): PatientSummaryResponse {
    return PatientSummaryResponseToJSONTyped(json, false);
}

export function PatientSummaryResponseToJSONTyped(value?: PatientSummaryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expressionId': value['expressionId'],
        'conceptGroupId': value['conceptGroupId'],
        'metaDataText': value['metaDataText'],
        'isCorrected': value['isCorrected'],
        'isInterpretable': value['isInterpretable'],
        'created': value['created'],
        'updated': value['updated'],
        'languageIso': value['languageIso'],
        'originalText': value['originalText'],
        'multiDosageText': value['multiDosageText'],
        'isMatched': value['isMatched'],
        'matchedText': value['matchedText'],
        'unMatchedText': value['unMatchedText'],
        'expressionType': value['expressionType'],
        'siteRoot': value['siteRoot'],
        'siteRootIndex': value['siteRootIndex'],
        'siteRootTerm': value['siteRootTerm'],
        'siteRootGroup': value['siteRootGroup'],
        'siteRootGroupIndex': value['siteRootGroupIndex'],
        'aggressorRoot': value['aggressorRoot'],
        'aggressorRootIndex': value['aggressorRootIndex'],
        'aggressorRootTerm': value['aggressorRootTerm'],
        'aggressorRootGroup': value['aggressorRootGroup'],
        'aggressorRootGroupIndex': value['aggressorRootGroupIndex'],
        'timelineStart': value['timelineStart'],
        'timelineEnd': value['timelineEnd'],
        'durationType': value['durationType'],
        'healthProType': value['healthProType'],
        'findingProcedureRoot': value['findingProcedureRoot'],
        'sctAdministrationRoute': value['sctAdministrationRoute'],
        'sctAdministrationRouteTerm': value['sctAdministrationRouteTerm'],
        'sctProxyKey': value['sctProxyKey'],
        'sctSite': value['sctSite'],
        'sctSiteTerm': value['sctSiteTerm'],
        'sctSiteProxy': value['sctSiteProxy'],
        'sctSiteProxyTerm': value['sctSiteProxyTerm'],
        'sctAggressor': value['sctAggressor'],
        'sctAggressorTerm': value['sctAggressorTerm'],
        'sctAggressorProxy': value['sctAggressorProxy'],
        'sctAggressorProxyTerm': value['sctAggressorProxyTerm'],
        'sctNestingAggressor': value['sctNestingAggressor'],
        'sctNestingAggressorTerm': value['sctNestingAggressorTerm'],
        'sctAggressorContentProxy': value['sctAggressorContentProxy'],
        'sctAggressorContentProxyTerm': value['sctAggressorContentProxyTerm'],
        'aggressorContentRoot': value['aggressorContentRoot'],
        'aggressorContentRootTerm': value['aggressorContentRootTerm'],
        'sctSubstance1': value['sctSubstance1'],
        'sctSubstance1Term': value['sctSubstance1Term'],
        'sctSubstance2': value['sctSubstance2'],
        'sctSubstance2Term': value['sctSubstance2Term'],
        'sctContentFamily2': value['sctContentFamily2'],
        'sctSubstance3': value['sctSubstance3'],
        'sctSubstance3Term': value['sctSubstance3Term'],
        'sctContentFamily3': value['sctContentFamily3'],
        'sctSubstance4': value['sctSubstance4'],
        'sctSubstance4Term': value['sctSubstance4Term'],
        'sctContentFamily4': value['sctContentFamily4'],
        'sctSubstance5': value['sctSubstance5'],
        'sctSubstance5Term': value['sctSubstance5Term'],
        'sctContentFamily5': value['sctContentFamily5'],
        'sctSubstance6': value['sctSubstance6'],
        'sctSubstance6Term': value['sctSubstance6Term'],
        'sctContentFamily6': value['sctContentFamily6'],
        'sctContentFamily1': value['sctContentFamily1'],
        'sctContentFamily1Index': value['sctContentFamily1Index'],
        'sctContentFamily1Term': value['sctContentFamily1Term'],
        'sctContentFamily2Index': value['sctContentFamily2Index'],
        'sctContentFamily2Term': value['sctContentFamily2Term'],
        'sctContentFamily3Index': value['sctContentFamily3Index'],
        'sctContentFamily3Term': value['sctContentFamily3Term'],
        'sctContentFamily4Index': value['sctContentFamily4Index'],
        'sctContentFamily4Term': value['sctContentFamily4Term'],
        'sctContentFamily5Index': value['sctContentFamily5Index'],
        'sctContentFamily5Term': value['sctContentFamily5Term'],
        'sctContentFamily6Index': value['sctContentFamily6Index'],
        'sctContentFamily6Term': value['sctContentFamily6Term'],
        'sctSubstanceKey': value['sctSubstanceKey'],
        'sctLabKey': value['sctLabKey'],
        'sctFindingProcedure': value['sctFindingProcedure'],
        'sctFindingProcedureTerm': value['sctFindingProcedureTerm'],
        'sctFindingProcedureProxy': value['sctFindingProcedureProxy'],
        'sctFindingProcedureProxyTerm': value['sctFindingProcedureProxyTerm'],
        'isSpecialtyOverImaging': value['isSpecialtyOverImaging'],
        'laterality': value['laterality'],
        'lateralityTerm': value['lateralityTerm'],
        'sctBodyQualifier': value['sctBodyQualifier'],
        'sctBodyQualifierTerm': value['sctBodyQualifierTerm'],
        'sctSubstanceReaction': value['sctSubstanceReaction'],
        'sctSubstanceReactionTerm': value['sctSubstanceReactionTerm'],
        'sctLabCollection': value['sctLabCollection'],
        'sctLabCollectionTerm': value['sctLabCollectionTerm'],
        'sctSiteFinding': value['sctSiteFinding'],
        'sctSiteFindingTerm': value['sctSiteFindingTerm'],
        'sctSiteFindingProxy': value['sctSiteFindingProxy'],
        'sctSiteFindingProxyTerm': value['sctSiteFindingProxyTerm'],
        'siteFindingRoot': value['siteFindingRoot'],
        'sctMorphology': value['sctMorphology'],
        'sctMorphologyTerm': value['sctMorphologyTerm'],
        'sctNormalityContext': value['sctNormalityContext'],
        'numericalValue': value['numericalValue'],
        'sctUnit': value['sctUnit'],
        'ucumUnit': value['ucumUnit'],
        'isNumerical': value['isNumerical'],
        'normalityType': value['normalityType'],
        'isNormal': value['isNormal'],
        'isOngoing': value['isOngoing'],
        'standardizedNumerical': value['standardizedNumerical'],
        'standardizedUpperLimit': value['standardizedUpperLimit'],
        'standardizedLowerLimit': value['standardizedLowerLimit'],
        'standardizedUnitTerm': value['standardizedUnitTerm'],
        'isNegated': value['isNegated'],
        'sctCertaintyContext': value['sctCertaintyContext'],
        'sctCertaintyContextTerm': value['sctCertaintyContextTerm'],
        'sctProcedureContext': value['sctProcedureContext'],
        'sctProcedureContextTerm': value['sctProcedureContextTerm'],
        'isFact': value['isFact'],
        'sctPersonInformer': value['sctPersonInformer'],
        'sctPersonInformerTerm': value['sctPersonInformerTerm'],
        'sctPersonSubject': value['sctPersonSubject'],
        'sctPersonSubjectTerm': value['sctPersonSubjectTerm'],
        'isFamilyHistory': value['isFamilyHistory'],
        'sctUnitTerm': value['sctUnitTerm'],
        'galenic': value['galenic'],
        'expressionCcl': ExpressionCCLToJSON(value['expressionCcl']),
        'entry': EntryToJSON(value['entry']),
        'conclusionGroup': ConclusionGroupToJSON(value['conclusionGroup']),
        'text': value['text'],
        'posoText': value['posoText'],
        'id': UiIdentifierToJSON(value['id']),
        'dbText': value['dbText'],
        'resultDocumentFile': ResultDocumentFileToJSON(value['resultDocumentFile']),
        'patientSummaryId': value['patientSummaryId'],
        'deletable': value['deletable'],
        'summaryType': value['summaryType'],
        'hasExclamation': value['hasExclamation'],
    };
}

